module.exports = __webpack_public_path__ + "img/exam_mainIcon.907de1ee.png";